import { Link } from "react-router-dom";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import { site, nav } from "@/data/content";
import CalendarConnect from "@/components/site/CalendarConnect";

export default function Footer() {
  return (
    <footer className="bg-[#2A2C29] text-[#f9f8f6]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-display text-3xl md:text-4xl leading-tight max-w-md">
              Un espacio de escucha, reflexión y elaboración del sufrimiento psíquico.
            </p>
            <Link
              to="/agenda"
              data-testid="footer-cta-agenda"
              className="inline-block mt-8 rounded-full bg-[#9C5A4B] text-[#f9f8f6] text-sm px-6 py-3 hover:bg-[#8A4A3C] transition-colors duration-300"
            >
              Agendar una primera entrevista
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="overline text-white/40 mb-5">Navegación</p>
            <ul className="space-y-2.5">
              {nav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-white/70 hover:text-white transition-colors duration-300 text-[15px]"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/40 mb-5">Contacto</p>
            <ul className="space-y-3.5 text-[15px] text-white/70">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 shrink-0 text-[#9C5A4B]" />
                <span>{site.location}</span>
              </li>
              <li>
                <a
                  href={`mailto:${site.email}`}
                  className="flex items-center gap-3 hover:text-white transition-colors duration-300"
                  data-testid="footer-email"
                >
                  <Mail size={16} className="shrink-0 text-[#9C5A4B]" />
                  {site.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${site.whatsappRaw}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 hover:text-white transition-colors duration-300"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle size={16} className="shrink-0 text-[#9C5A4B]" />
                  {site.whatsapp}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} {site.name} · {site.role}</span>
          <div className="flex items-center gap-5">
            <CalendarConnect />
            <span>{site.domain}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
